<div class="spinner">
  <mat-spinner [diameter]="20"></mat-spinner>
</div>
